import { createContext, useContext, useMemo } from 'react';

const MentorshipsContext = createContext();

export const MentorshipsContextProvider = ({
  children,
  owner,
  menuName,
  mentorLabel,
  menteeLabel,
  mentorApplicationFormText,
  menteeApplicationFormText,
  mentorApplicationConfig,
}) => {
  const value = useMemo(
    () => ({
      owner,
      menuName,
      mentorLabel,
      menteeLabel,
      mentorApplicationFormText,
      menteeApplicationFormText,
      mentorApplicationConfig,
    }),
    [
      owner,
      menuName,
      mentorLabel,
      menteeLabel,
      mentorApplicationFormText,
      menteeApplicationFormText,
      mentorApplicationConfig,
    ],
  );

  return (
    <MentorshipsContext.Provider value={value}>
      {children}
    </MentorshipsContext.Provider>
  );
};

export const useMentorshipsContext = () => useContext(MentorshipsContext);

export default MentorshipsContext;
